import React, { createContext, useState } from "react";

import type { ReceiptListRow } from "../hooks/useReceiptsList";

// Frontend cap: select-all and add-to-selection are bounded to this many
// receipts to keep bulk Accept/Reject responsive. Backend may reject larger
// batches independently.
export const RECEIPTS_BULK_SELECTION_LIMIT = 100;

export type SelectionState = {
  [receiptUuid: string]: ReceiptListRow;
};

type SelectionContextType = {
  selectionState: SelectionState;
  setSelectionState: React.Dispatch<React.SetStateAction<SelectionState>>;
};

export const SelectionContext = createContext({} as SelectionContextType);

export const SelectionProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [selectionState, setSelectionState] = useState<SelectionState>({});

  return (
    <SelectionContext.Provider value={{ selectionState, setSelectionState }}>
      {children}
    </SelectionContext.Provider>
  );
};
